import {
  ActionIcon,
  Avatar,
  Stack,
} from "@mantine/core";
import { getInitials } from "../../../../utils/getInitials";

  
// OwnerCell Component
export const OwnerAvatar: React.FC<any> = ({ data, size = 16 }) => {
  const owner = data.owner || {};
  const userName = owner.username || "";
  const ownerName = owner.name || "";
  const userPic = owner.picture || "";
  const name = ownerName || userName;
  const pic = userPic;
  
  return (
    <Stack align="center" justify="center">
      <ActionIcon 
        variant="transparent"
        styles={{
          root: {
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'transparent'
            }
          }
        }}
      >
        <Avatar src={pic} radius="xl" size={size}>
          {getInitials(name)}
        </Avatar>
      </ActionIcon>
    </Stack>
  );
};